export const woopValidatorRegex = /^[1-9]$/
export const overnightIndicatorValidator = /^[0-9]$/
export const operatorValidatorRegex = /^[0-9a-zA-Z]{2}[a-zA-Z]?$/
export const doopValidatorRegex = /^[0-1]?(0|2)?(0|3)?(0|4)?(0|5)?(0|6)?(0|7)?$/
export const ICAOAircraftTypeValidatorRegex = /^[0-9a-zA-Z]{2,4}$/
export const IATAAircraftTypeValidatorRegex = /^[0-9a-zA-Z]{3}$/
export const aircraftRegRegex = /^[a-zA-Z0-9]{1,9}$/
export const aircraftRegSearchRegex = /^[a-zA-Z0-9*?]{1,9}$/
export const serviceNoRegex = /^\d{1,4}[a-zA-Z]?$/
export const serviceNoSearchRegex = /^(\d|[*?]){1,4}[a-zA-Z*?]?$/
export const seatsValidatorRegex = /^[0-9]{1,3}$/
export const IATAStationRegex = /^[a-zA-Z]{3}$/
export const ICAOStationRegex = /^[a-zA-Z0-9]{3,4}$/
export const IATAStationOrCCRegex = /^[a-zA-Z]{2,3}$/ // country codes are 2 alpha
export const ICAOStationOrCCRegex = /^[a-zA-Z]{2}|[a-zA-Z0-9]{3,4}$/
export const minGroundTimerValidatorRegex = /^\d{1,4}$/
export const time9999ValidatorRegex =
  /^((([0-1][0-9])|(2[0-3]))[0-5][0-9])|(9999)$/
export const timeValidatorRegex = /^(([0-1][0-9])|(2[0-3]))[0-5][0-9]$/
export const integersOnlyRegex = /^\d+$/
export const operatorTextRegex = /^[a-zA-Z0-9 ]+$/
export const slotIdRegex = /^[0-9a-zA-Z*?]*$/
export const PPRIdRegex = /^[0-9a-zA-Z/*?]*$/
